import { textEncoder } from './textEncoder';

export async function sha256(data: string): Promise<ArrayBuffer> {
  return crypto.subtle.digest('SHA-256', textEncoder.encode(data));
}
